// src/services/RequisitoService.js
import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const RequisitoService = {
    fetchRequisitos: async (token) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ventas/requisitos'), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data || [];
        } catch (error) {
            console.error('Error en RequisitoService.fetchRequisitos:', error);
            throw error;
        }
    },
};
